import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

export default class extends Controller {
  static values = { url: String, category: String }

  connect() {
    this.sortable = Sortable.create(this.element, {
      handle: ".handle",
      animation: 150,
      ghostClass: "table-active",
      group: "trackers",
      onEnd: this.#onEnd.bind(this),
      onAdd: (event) => this.#toggleEmptyHintFor(event.to),
      onRemove: (event) => this.#toggleEmptyHintFor(event.from)
    })
    this.#toggleEmptyHint()
  }

  disconnect() {
    this.sortable?.destroy()
  }

  async #onEnd(event) {
    // Collect positions from the target list (where the item was dropped)
    const targetBody = event.to
    const targetCategory = targetBody.dataset.sortableCategoryValue || ""
    const rows = targetBody.querySelectorAll("tr[data-id]")
    const positions = {}
    rows.forEach((row, index) => {
      positions[row.dataset.id] = {
        position: index,
        category_id: targetCategory
      }
    })

    // Also re-index the source list if it's different
    if (event.from !== event.to) {
      const sourceRows = event.from.querySelectorAll("tr[data-id]")
      sourceRows.forEach((row, index) => {
        positions[row.dataset.id] = {
          position: index,
          category_id: event.from.dataset.sortableCategoryValue || ""
        }
      })
    }

    const csrfToken = document.querySelector('meta[name="csrf-token"]').content
    await fetch(this.urlValue, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": csrfToken,
        "Accept": "application/json"
      },
      body: JSON.stringify({ positions })
    })

    // Update badge counts for source and target categories
    this.#updateBadgeCount(event.to)
    if (event.from !== event.to) {
      this.#updateBadgeCount(event.from)
    }
  }

  #toggleEmptyHint() {
    this.#toggleEmptyHintFor(this.element)
  }

  #toggleEmptyHintFor(tbody) {
    const hint = tbody.closest(".card-body")?.querySelector("[data-sortable-empty-hint]")
    if (!hint) return
    const hasRows = tbody.querySelectorAll("tr[data-id]").length > 0
    hint.style.display = hasRows ? "none" : ""
  }

  #updateBadgeCount(tbody) {
    const card = tbody.closest(".card")
    if (!card) return
    const badge = card.querySelector(".card-header .badge")
    if (!badge) return
    const count = tbody.querySelectorAll("tr[data-id]").length
    badge.textContent = count
  }
}
